import { Module } from "vuex";
import state, { VisitSearchState } from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import RootState from "@/legacy/store/rootState";

const visitModule: Module<VisitSearchState, RootState> = {
  actions,
  state,
  getters,
  mutations,
};

export default visitModule;
